export default "/5253cd0b512a66889ef5afb5e2caf631078665a1/a92d826d80900dda6092d3b109ffaee1.svg";